export default function($) {
$(document).ready(function() {
    const slider = $('.news-slider'),
          slide = $('.js-news-slide'),
          prevArrow = $('.js-arrow-prev'),
          nextArrow = $('.js-arrow-next'),
          slideCount = $('.js-news-slide').length;

    let slideIndex = 0;

    slide.hide();
    slide.first().show();
    slide.first().removeClass('absolute').addClass('relative');

    // Gestionnaire d'événement pour la flèche suivante
    nextArrow.click(function() {
      if (slideIndex < slideCount - 1) {
        var currentSlide = $(this).parents('.js-news-slide')
        var index = currentSlide.data('index')
        var nextIndex = slideIndex+1;
        if ( index == slideIndex ) {
          currentSlide.fadeOut('fast');
          currentSlide.removeClass('relative').addClass('absolute');
          $(this).parents('.news-slider').find('#news-slide-'+nextIndex).fadeIn('slow').removeClass('absolute').addClass('relative')
        }
        slideIndex++;
        prevArrow.show(); // Afficher la flèche précédente car nous ne sommes plus sur le premier élément

        // Cacher la flèche suivante si nous sommes sur le dernier élément
        if (slideIndex === slideCount - 1) {
          nextArrow.hide();
        }
      }
    });

    // Gestionnaire d'événement pour la flèche précédente
    prevArrow.click(function() {
      if (slideIndex > 0) {
        var currentSlide = $(this).parents('.js-news-slide')
        var index = currentSlide.data('index')
        var prevIndex = slideIndex-1;
        if ( index == slideIndex ) {
          currentSlide.fadeOut('fast');
          currentSlide.removeClass('relative').addClass('absolute');
          $(this).parents('.news-slider').find('#news-slide-'+prevIndex).fadeIn('slow').removeClass('absolute').addClass('relative')
        }
        slideIndex--;
        nextArrow.show(); // Afficher la flèche suivante car nous ne sommes plus sur le dernier élément

        // Cacher la flèche précédente si nous sommes de retour au premier élément
        if (slideIndex === 0) {
          prevArrow.hide();
        }
      }
    });
  });
}
